import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ComplexCases() {
  const tableData = [{
    sit: 'Tu hijo no termina ninguna actividad',
    sin: 'Improvisás y abandona a los 2 minutos',
    con: 'Protocolo de atención progresiva. Paso a paso.'
  }, {
    sit: 'Hipersensibilidad o frustración rápida',
    sin: 'Las actividades lo sobreestimulan',
    con: 'Versión sensorial adaptada. Lista.'
  }, {
    sit: 'TDAH: no puede sostener el foco',
    sin: 'Abandona y pide el celular',
    con: 'Actividades de concentración gradual. Funcionan.'
  }, {
    sit: 'La frustración dura más de 20 minutos',
    sin: 'No sabés cuándo ni cómo intervenir',
    con: 'Protocolo de regulación emocional completo.'
  }, {
    sit: 'Querés mostrar avances al pediatra',
    sin: 'No tenés nada documentado',
    con: 'Registro de progreso listo para imprimir.'
  }];
  const kitIncludes = ['Protocolo de atención para niños con baja tolerancia', 'Actividades de regulación sensorial', 'Guía para familias con TEA y TDAH', 'Sistema visual para niños no verbales', 'Registro para compartir con profesionales', 'Fichas de desescalada de crisis'];
  return <section className="bg-dark-800 py-12 px-4" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <div className="text-center mb-8" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-3" data-id="element-39">
            🕊️ ¿QUÉ AGREGA EL KIT MENTE BLINDADA?
          </h2>
        </div>

        <div className="overflow-x-auto mb-8 rounded-2xl border border-primary/40 shadow-xl" data-id="element-40">
          <table className="w-full text-left border-collapse" data-id="element-41">
            <thead data-id="element-42">
              <tr className="bg-dark-900 border-b border-primary/40" data-id="element-43">
                <th className="p-4 text-cream font-bold w-1/3" data-id="element-44">
                  Situación en casa
                </th>
                <th className="p-4 font-bold w-1/3 text-gold" data-id="element-45">
                  <div className="flex items-center" data-id="element-46">
                    <XCircle className="w-5 h-5 mr-2" data-id="element-47" /> Sin Kit
                  </div>
                </th>
                <th className="p-4 font-bold w-1/3 text-primary" data-id="element-48">
                  <div className="flex items-center" data-id="element-49">
                    <CheckCircle2 className="w-5 h-5 mr-2" data-id="element-50" /> Con Kit
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-primary/20" data-id="element-51">
              {tableData.map((row, i) => <tr key={i} className="bg-dark-800 hover:bg-dark-900/50 transition-colors" data-id="element-52">
                  <td className="p-4 text-cream/90 font-medium" data-id="element-53">{row.sit}</td>
                  <td className="p-4 text-cream/60" data-id="element-54">{row.sin}</td>
                  <td className="p-4 text-primary font-medium" data-id="element-55">{row.con}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-primary-dark rounded-3xl p-6 md:p-8 border border-primary/40 max-w-3xl mx-auto" data-id="element-56">
          <h3 className="text-xl md:text-2xl font-bold text-cream mb-5 flex items-center" data-id="element-57">
            <span className="text-cta mr-3" data-id="element-58">✅</span> El Kit Mente Blindada
            incluye:
          </h3>
          <ul className="space-y-3" data-id="element-59">
            {kitIncludes.map((item, i) => <li key={i} className="flex items-start text-cream/90" data-id="element-60">
                <CheckCircle2 className="w-5 h-5 text-primary mr-3 shrink-0 mt-1" data-id="element-61" />
                <span className="text-base md:text-lg" data-id="element-62">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}